"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  CryptoCurrencyLitecoin: ['crypto-currency-litecoin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M10.5,4.5,8.543,16.632a.522.522,0,0,0,.106.429.508.508,0,0,0,.4.189h8.581', 'M5.864 13.534L14.045 9.955']],
  CryptoCurrencyBitcoinChip: ['crypto-currency-bitcoin-chip', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.5,15V9h2.25a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M10.5 12L12.75 12', 'M12 9L12 7.5', 'M12 15L12 16.5', 'M7.5 4.5L7.5 1.5', 'M12 4.5L12 1.5', 'M16.5 4.5L16.5 1.5', 'M7.5 22.5L7.5 19.5', 'M12 22.5L12 19.5', 'M16.5 22.5L16.5 19.5', 'M19.5 7.5L22.5 7.5', 'M19.5 12L22.5 12', 'M19.5 16.5L22.5 16.5', 'M1.5 7.5L4.5 7.5', 'M1.5 12L4.5 12', 'M1.5 16.5L4.5 16.5', 'M4.500 4.500 L19.500 4.500 L19.500 19.500 L4.500 19.500 Z']],
  CryptoCurrencyBitcoinBrowser: ['crypto-currency-bitcoin-browser', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,19.5h3a1.5,1.5,0,0,0,1.5-1.5V3a1.5,1.5,0,0,0-1.5-1.5H2.25A1.5,1.5,0,0,0,.75,3V18a1.5,1.5,0,0,0,1.5,1.5H6', 'M0.75 6L23.25 6', 'M9 15.75L13.5 15.75', 'M13.5 11.25L13.5 9', 'M13.5 20.25L13.5 22.5', 'M10.5 11.25L10.5 9', 'M10.5 20.25L10.5 22.5', 'M13.5,11.25a2.25,2.25,0,0,1,0,4.5,2.25,2.25,0,0,1,0,4.5H9v-9Z']],
  CryptoCurrencyBitcoin: ['crypto-currency-bitcoin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.000 10.500 A6.000 6.000 0 1 0 18.000 10.500 A6.000 6.000 0 1 0 6.000 10.500 Z', 'M10.5,13.5v-6h2.25a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M10.5 10.5L12.75 10.5', 'M12 7.5L12 6.75', 'M12 13.5L12 14.25', 'M9.750 21.000 A2.250 2.250 0 1 0 14.250 21.000 A2.250 2.250 0 1 0 9.750 21.000 Z', 'M0.750 3.000 A2.250 2.250 0 1 0 5.250 3.000 A2.250 2.250 0 1 0 0.750 3.000 Z', 'M18.750 3.000 A2.250 2.250 0 1 0 23.250 3.000 A2.250 2.250 0 1 0 18.750 3.000 Z', 'M12 18.75L12 16.5', 'M4.729 4.44L7.391 6.659', 'M19.271 4.44L16.609 6.659']],
  CryptoCurrencyBitcoinBubble: ['crypto-currency-bitcoin-bubble', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,12a3.5,3.5,0,0,0-2.443-3.337,3.5,3.5,0,0,0-4.72-4.72,3.5,3.5,0,0,0-6.674,0,3.5,3.5,0,0,0-4.72,4.72,3.5,3.5,0,0,0,0,6.674,3.5,3.5,0,0,0,4.72,4.72,3.5,3.5,0,0,0,6.674,0,3.5,3.5,0,0,0,4.72-4.72A3.5,3.5,0,0,0,22.5,12Z', 'M9 12L13.5 12', 'M12 7.5L12 6', 'M12 16.5L12 18', 'M13.5,7.5a2.25,2.25,0,0,1,0,4.5,2.25,2.25,0,0,1,0,4.5H9v-9Z']],
  CryptoCurrencyBitcoinDecrease: ['crypto-currency-bitcoin-decrease', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 18.75L22.5 23.25 18 23.25', 'M22.5,23.25,17.45,18.2a2.252,2.252,0,0,0-2.237-.565L9.5,19.161a2.249,2.249,0,0,1-2.172-.582L1.5,12.746', 'M3.148,9.739A7.5,7.5,0,1,1,15,14.253', 'M9,11.25v-6h2.25a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M9 8.25L11.25 8.25', 'M10.5 5.25L10.5 3.75', 'M10.5 11.25L10.5 12.75']],
  CryptoCurrencyBitcoinDollarExchange: ['crypto-currency-bitcoin-dollar-exchange', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,3.75H16.717a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H17.25', 'M17.25 3.75L17.25 3', 'M18.03,12.7A6,6,0,1,0,11.3,5.958', 'M15.75,15.75a7.5,7.5,0,0,0-7.5-7.5', 'M2.25,11.25a7.5,7.5,0,1,0,12.5,8.25', 'M6.75,18.75v-6H9a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M6.75 15.75L9 15.75', 'M8.25 12.75L8.25 11.25', 'M8.25 18.75L8.25 20.25', 'M0.75 4.5L3 8.25 6.75 6', 'M8.189.9A6.752,6.752,0,0,0,3.772,7.786', 'M23.25 19.5L21 15.75 17.25 18', 'M15.811,23.1a6.752,6.752,0,0,0,4.417-6.884']],
  CryptoCurrencyBitcoinDollarUnequal1: ['crypto-currency-bitcoin-dollar-unequal-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 6.75L5.25 6.75', 'M3.75 2.25L3.75 0.75', 'M3.75 11.25L3.75 12.75', 'M5.25,2.25a2.25,2.25,0,0,1,0,4.5,2.25,2.25,0,0,1,0,4.5H.75v-9Z', 'M12 18L7.5 23.25 16.5 23.25 12 18z', 'M23.25 21L0.75 15', 'M22.5,6H18.581a2.081,2.081,0,0,0-.452,4.112l3.492.776A2.081,2.081,0,0,1,21.169,15H17.25', 'M19.5 6L19.5 4.5', 'M19.5 16.5L19.5 15']],
  CryptoCurrencyBitcoinImac: ['crypto-currency-bitcoin-imac', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.25 23.25L15.75 23.25', 'M18,.75h2.25a3,3,0,0,1,3,3v12a3,3,0,0,1-3,3H3.75a3,3,0,0,1-3-3v-12a3,3,0,0,1,3-3H6', 'M9 8.25L13.5 8.25', 'M13.5 3.75L13.5 1.5', 'M13.5 12.75L13.5 15', 'M10.5 3.75L10.5 1.5', 'M10.5 12.75L10.5 15', 'M13.5,3.75a2.25,2.25,0,0,1,0,4.5,2.25,2.25,0,0,1,0,4.5H9v-9Z', 'M12 18.75L12 23.25']],
  CryptoCurrencyBitcoinMonitor: ['crypto-currency-bitcoin-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5 23.25L16.5 23.25', 'M0.75 15.75L23.25 15.75', 'M18,2.25h3.75a1.5,1.5,0,0,1,1.5,1.5V18a1.5,1.5,0,0,1-1.5,1.5H2.25A1.5,1.5,0,0,1,.75,18V3.75a1.5,1.5,0,0,1,1.5-1.5H6', 'M12.75,11.25a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M9.75 6.75L12.937 6.75', 'M12 2.25L12 0.75', 'M12 12.75L12 11.25', 'M12 19.5L12 23.25']],
  CryptoCurrencyBitcoinMonitorMining: ['crypto-currency-bitcoin-monitor-mining', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,6.75H1.5A.75.75,0,0,1,.75,6V1.5A.75.75,0,0,1,1.5.75h6a.75.75,0,0,1,.75.75v3', 'M8.25,19.5v3a.75.75,0,0,1-.75.75h-6a.75.75,0,0,1-.75-.75V18a.75.75,0,0,1,.75-.75H6', 'M15.75,4.5v-3A.75.75,0,0,1,16.5.75h6a.75.75,0,0,1,.75.75V6a.75.75,0,0,1-.75.75H18', 'M18,17.25h4.5a.75.75,0,0,1,.75.75v4.5a.75.75,0,0,1-.75.75h-6a.75.75,0,0,1-.75-.75v-3', 'M11.25 3L12.75 3', 'M11.25 21.75L12.75 21.75', 'M3.75 9.75L3.75 10.5', 'M3.75 13.5L3.75 14.25', 'M20.25 9.75L20.25 10.5', 'M20.25 13.5L20.25 14.25', 'M12.75,16.5a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M9.75 12L12.937 12', 'M12 7.5L12 6', 'M12 18L12 16.5']],
  CryptoCurrencyBitcoinMonitorMining1: ['crypto-currency-bitcoin-monitor-mining-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9 21L15 21', 'M12 17.25L12 21', 'M17.25,8.25a1.5,1.5,0,0,1,1.5,1.5v6a1.5,1.5,0,0,1-1.5,1.5H6.75a1.5,1.5,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,1.5-1.5', 'M0.750 2.250 A1.500 1.500 0 1 0 3.750 2.250 A1.500 1.500 0 1 0 0.750 2.250 Z', 'M3.311 3.311L4.875 4.875', 'M20.250 2.250 A1.500 1.500 0 1 0 23.250 2.250 A1.500 1.500 0 1 0 20.250 2.250 Z', 'M20.689 3.311L19.125 4.875', 'M0.750 21.750 A1.500 1.500 0 1 0 3.750 21.750 A1.500 1.500 0 1 0 0.750 21.750 Z', 'M3.311 20.689L4.875 19.125', 'M20.250 21.750 A1.500 1.500 0 1 0 23.250 21.750 A1.500 1.500 0 1 0 20.250 21.750 Z', 'M20.689 20.689L19.125 19.125', 'M12.75,12.75a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M9.75 8.25L12.937 8.25', 'M12 3.75L12 2.25', 'M12 14.25L12 12.75']],
  CryptoCurrencyBitcoinShield: ['crypto-currency-bitcoin-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9 10.5L13.5 10.5', 'M12 6L12 4.5', 'M12 15L12 16.5', 'M13.5,6a2.25,2.25,0,0,1,0,4.5,2.25,2.25,0,0,1,0,4.5H9V6Z', 'M23.25,9.938A13.5,13.5,0,0,1,12,23.25,13.5,13.5,0,0,1,.75,9.938V2.25A1.5,1.5,0,0,1,2.25.75h19.5a1.5,1.5,0,0,1,1.5,1.5Z']],
  CryptoCurrencyBitcoinSmartphone: ['crypto-currency-bitcoin-smartphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25 18.75L18.75 18.75', 'M5.250 0.750 L18.750 0.750 L18.750 23.250 L5.250 23.250 Z', 'M12.75,14.25a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M9.75 9.75L12.937 9.75', 'M12 5.25L12 3.75', 'M12 15.75L12 14.25']],
  CryptoCurrencyBitcoinWallet: ['crypto-currency-bitcoin-wallet', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,18.658a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M9.75 14.158L12.937 14.158', 'M12 9.658L12 8.158', 'M12 20.158L12 18.658', 'M0.750 5.158 L23.250 5.158 L23.250 23.158 L0.750 23.158 Z', 'M20.25,5.158V2.342A1.5,1.5,0,0,0,18.578.851L3.406,2.6A3,3,0,0,0,.75,5.582V6.658']],
  CryptoCurrencyDogecoin: ['crypto-currency-dogecoin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M18,12a5.13,5.13,0,0,1-5,5.25H9V6.75h4A5.13,5.13,0,0,1,18,12Z', 'M8.932 6.75L6.375 6.75', 'M8.932 17.25L6.375 17.25']],
  CryptoCurrencyBitcoinWorld: ['crypto-currency-bitcoin-world', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.5,23.151A11.251,11.251,0,1,1,23.151,10.5', 'M9.289,22.921C7.767,20.689,6.75,16.633,6.75,12S7.767,3.311,9.289,1.079', 'M0.75 11.25L9.75 11.25', 'M2.999 5.25L21 5.25', 'M2.048 17.25L8.25 17.25', 'M14.711,1.079A17.011,17.011,0,0,1,17.019,8.25', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M15.75,20.25v-6H18a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M15.75 17.25L18 17.25', 'M17.25 14.25L17.25 13.5', 'M17.25 20.25L17.25 21']],
  CryptoCurrencyNxtcoin: ['crypto-currency-nxtcoin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M4.841,9H10.15a.511.511,0,0,1,.457.276L13.534,15h5.625', 'M14.045,9h5.309a.512.512,0,0,1,.458.28l2.981,5.9', 'M1.211,8.8,4.188,14.72a.512.512,0,0,0,.458.28H9.955']],
  CryptoCurrencyRipple: ['crypto-currency-ripple', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.753 12.000 A11.247 11.247 0 1 0 23.247 12.000 A11.247 11.247 0 1 0 0.753 12.000 Z', 'M12.624,6.9A2.529,2.529,0,0,0,13.047,9.2l-.5.809a2.044,2.044,0,0,1-1.736.965H10.25A2.561,2.561,0,0,0,7.157,9.552a2.51,2.51,0,0,0-1.708,1.741,2.557,2.557,0,0,0,4.8,1.729H10.6a2.044,2.044,0,0,1,1.834,1.142l.371.754a2.466,2.466,0,0,0-.141,2.034,2.552,2.552,0,0,0,4.956-.831,2.427,2.427,0,0,0-.8-1.741,2.287,2.287,0,0,0-2.372-.762l-.267-.541a2.044,2.044,0,0,1,.1-1.984l.563-.9c.075.007.147.023.224.023A2.559,2.559,0,1,0,12.624,6.9Z']],
  CryptoCurrencyBitcoinCircle: ['crypto-currency-bitcoin-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9 12L13.5 12', 'M12 7.5L12 6', 'M12 16.5L12 18', 'M13.5,7.5a2.25,2.25,0,0,1,0,4.5,2.25,2.25,0,0,1,0,4.5H9v-9Z', 'M1.500 12.000 A10.500 10.500 0 1 0 22.500 12.000 A10.500 10.500 0 1 0 1.500 12.000 Z']],
  CryptoCurrencyBitcoinCode: ['crypto-currency-bitcoin-code', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5.75h.75A.75.75,0,0,1,3,1.5V6.75', 'M1.5 6.75L4.5 6.75', 'M10.5,5.25a1.5,1.5,0,0,1-3,0v-3a1.5,1.5,0,0,1,3,0Z', 'M13.5.75h.75A.75.75,0,0,1,15,1.5V6.75', 'M13.5 6.75L16.5 6.75', 'M22.5,5.25a1.5,1.5,0,0,1-3,0v-3a1.5,1.5,0,0,1,3,0Z', 'M15,9a1.5,1.5,0,0,1,1.5,1.5V12', 'M19.5,9h.75a.75.75,0,0,1,.75.75V15', 'M19.5 15L22.5 15', 'M22.5,21.75a1.5,1.5,0,0,1-3,0v-3a1.5,1.5,0,0,1,3,0Z', 'M6.75 15.75L9.25 15.75', 'M8.25 12.75L8.25 12', 'M8.25 18.75L8.25 19.5', 'M9.25,12.75a1.393,1.393,0,0,1,1.25,1.5,1.393,1.393,0,0,1-1.25,1.5,1.393,1.393,0,0,1,1.25,1.5,1.393,1.393,0,0,1-1.25,1.5H6.75v-6Z', 'M1.500 15.750 A6.750 6.750 0 1 0 15.000 15.750 A6.750 6.750 0 1 0 1.500 15.750 Z', 'M15 21.75L15 23.25', 'M13.5 23.25L16.5 23.25']],
  CryptoCurrencyBitcoinExchange1: ['crypto-currency-bitcoin-exchange-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.707,6A9,9,0,0,0,3,12v.75', 'M5.293,18A9,9,0,0,0,21,12v-.75', 'M18.75 13.5L21 11.25 23.25 13.5', 'M5.25 10.5L3 12.75 0.75 10.5', 'M12.75,16.5a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M9.75 12L12.937 12', 'M12 7.5L12 6', 'M12 18L12 16.5']],
  CryptoCurrencyBitcoinCoins: ['crypto-currency-bitcoin-coins', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 16.500 A6.000 6.000 0 1 0 23.250 16.500 A6.000 6.000 0 1 0 11.250 16.500 Z', 'M15.75,19.5v-6H18a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M15.75 16.5L18 16.5', 'M17.25 13.5L17.25 12.75', 'M17.25 19.5L17.25 20.25', 'M0.750 4.500 A6 3 0 1 0 12.750 4.500 A6 3 0 1 0 0.750 4.500 Z', 'M12.75,7.5c0,1.657-2.686,3-6,3s-6-1.343-6-3', 'M12.75 9L12.75 4.5', 'M.75,4.5v15c0,1.657,2.686,3,6,3A11.284,11.284,0,0,0,9,22.277', 'M.75,16.5c0,1.657,2.686,3,6,3A11.284,11.284,0,0,0,9,19.277', 'M.75,13.5c0,1.657,2.686,3,6,3A11.284,11.284,0,0,0,9,16.277', 'M.75,10.5c0,1.657,2.686,3,6,3A11.284,11.284,0,0,0,9,13.277']],
  CryptoCurrencyBitcoinCloud: ['crypto-currency-bitcoin-cloud', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.375,16.5A4.875,4.875,0,1,0,15.61,7.615a7.5,7.5,0,1,0-8.831,8.741', 'M13.5,21a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M10.5 16.5L13.687 16.5', 'M12.75 12L12.75 10.5', 'M12.75 22.5L12.75 21']],
  CryptoCurrencyBitcoinMonitorShield: ['crypto-currency-bitcoin-monitor-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,5.25a1.5,1.5,0,0,1,1.5,1.5V18a1.5,1.5,0,0,1-1.5,1.5H2.25A1.5,1.5,0,0,1,.75,18V6.75a1.5,1.5,0,0,1,1.5-1.5', 'M18.75,9A7.854,7.854,0,0,1,12,16.5,7.854,7.854,0,0,1,5.25,9V2.25A1.5,1.5,0,0,1,6.75.75h10.5a1.5,1.5,0,0,1,1.5,1.5Z', 'M8.25 23.25L15.75 23.25', 'M12 19.5L12 23.25', 'M10.5,10.5v-6h2.25a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M10.5 7.5L12.75 7.5', 'M12 4.5L12 3.75', 'M12 10.5L12 11.25']],
  CryptoCurrencyBitcoinDollarUnequal: ['crypto-currency-bitcoin-dollar-unequal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 10.5L5.25 10.5', 'M3.75 6L3.75 4.5', 'M3.75 15L3.75 16.5', 'M5.25,6a2.25,2.25,0,0,1,0,4.5,2.25,2.25,0,0,1,0,4.5H.75V6Z', 'M12 18L7.5 23.25 16.5 23.25 12 18z', 'M0.75 20.25L23.25 15', 'M22.5,2.25H18.581a2.081,2.081,0,0,0-.452,4.112l3.492.776a2.081,2.081,0,0,1-.452,4.112H17.25', 'M19.5 2.25L19.5 0.75', 'M19.5 12.75L19.5 11.25']],
  CryptoCurrencyBitcoinExhcange: ['crypto-currency-bitcoin-exhcange', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.684,10.5a6,6,0,1,0-9.368,0', 'M10.5,9.75v-6h2.25a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M10.5 6.75L12.75 6.75', 'M12 3.75L12 3', 'M12 9.75L12 10.5', 'M0.750 13.500 L10.500 13.500 L10.500 20.250 L0.750 20.250 Z', 'M3 23.25L8.25 23.25', 'M5.625 20.25L5.625 23.25', 'M13.500 13.500 L23.250 13.500 L23.250 20.250 L13.500 20.250 Z', 'M15.75 23.25L21 23.25', 'M18.375 20.25L18.375 23.25']],
  CryptoCurrencyBitcoinDollarEqual: ['crypto-currency-bitcoin-dollar-equal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 7.5L5.25 7.5', 'M3.75 3L3.75 1.5', 'M3.75 12L3.75 13.5', 'M5.25,3a2.25,2.25,0,0,1,0,4.5,2.25,2.25,0,0,1,0,4.5H.75V3Z', 'M12 17.25L7.5 22.5 16.5 22.5 12 17.25z', 'M0.75 16.5L23.25 16.5', 'M22.5,3H18.581a2.081,2.081,0,0,0-.452,4.112l3.492.776A2.081,2.081,0,0,1,21.169,12H17.25', 'M19.5 3L19.5 1.5', 'M19.5 13.5L19.5 12']],
  CryptoCurrencyBitcoinGive: ['crypto-currency-bitcoin-give', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 14.25L0.75 23.25', 'M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75', 'M6.75 18.75L10.5 18.75', 'M18.56,17.653A9,9,0,1,0,5.551,12.114', 'M15,14.25a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5H12v9Z', 'M12 9.75L15.188 9.75', 'M14.25 5.25L14.25 3.75', 'M14.25 15.75L14.25 14.25']],
  CryptoCurrencyBitcoinIncrease: ['crypto-currency-bitcoin-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 17.248L22.5 12.748 18 12.748', 'M22.5,12.748,17.45,17.8a2.252,2.252,0,0,1-2.237.565L9.5,16.837a2.251,2.251,0,0,0-2.172.583L1.5,23.252', 'M17.852,9.737A7.5,7.5,0,1,0,6,14.251', 'M9,11.248v-6h2.25a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M9 8.248L11.25 8.248', 'M10.5 5.248L10.5 3.748', 'M10.5 11.248L10.5 12.748']],
  CryptoCurrencyBitcoinLock: ['crypto-currency-bitcoin-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,21.75a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M9.75 17.25L12.937 17.25', 'M12 12.75L12 11.25', 'M12 23.25L12 21.75', 'M6.75,23.25h-3a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5h16.5a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5H16.5', 'M17.25,8.25H6.75V6a5.25,5.25,0,0,1,10.5,0Z']],
  CryptoCurrencyBitcoinNetwork: ['crypto-currency-bitcoin-network', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.25A11.25,11.25,0,0,1,12,.75', 'M1.398 8.25L11.25 8.25', 'M1.402 15.75L11.25 15.75', 'M12,23.25c-2.9,0-5.25-5.037-5.25-11.25S9.1.75,12,.75', 'M23.25,8.625A3.375,3.375,0,0,1,19.875,12H14.25V5.25h5.625A3.375,3.375,0,0,1,23.25,8.625Z', 'M23.25,15.375a3.375,3.375,0,0,1-3.375,3.375H14.25V12h5.625A3.375,3.375,0,0,1,23.25,15.375Z', 'M16.5 5.25L16.5 3', 'M19.5 5.25L19.5 3', 'M16.5 21L16.5 18.75', 'M19.5 21L19.5 18.75']],
  CryptoCurrencyBitcoinStackCoins: ['crypto-currency-bitcoin-stack-coins', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 15.000 A6.000 6.000 0 1 0 23.250 15.000 A6.000 6.000 0 1 0 11.250 15.000 Z', 'M15.75,18V12H18a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M15.75 15L18 15', 'M17.25 12L17.25 11.25', 'M17.25 18L17.25 18.75', 'M8.25,16.5H3a.75.75,0,0,0-.75.75v3A.75.75,0,0,0,3,21h7.5', 'M9,12H4.5a.75.75,0,0,0-.75.75v3a.75.75,0,0,0,.75.75H8.25', 'M11.25,7.5H1.5a.75.75,0,0,0-.75.75v3A.75.75,0,0,0,1.5,12H9', 'M14.25,6.75v-3A.75.75,0,0,0,13.5,3H3a.75.75,0,0,0-.75.75v3A.75.75,0,0,0,3,7.5']],
  CryptoCurrencyBitcoinUnlock: ['crypto-currency-bitcoin-unlock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,21.75a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M9.75 17.25L12.937 17.25', 'M12 12.75L12 11.25', 'M12 23.25L12 21.75', 'M6.75,23.25h-3a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5h16.5a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5H16.5', 'M7.3,3.651A5.251,5.251,0,0,1,17.25,6V8.25']],
  CryptoCurrencyInfinitecoin: ['crypto-currency-infinitecoin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M12.068,12.068S8.725,15.136,7,15.136A3.068,3.068,0,1,1,7,9C8.725,9,12.068,12.068,12.068,12.068Z', 'M12.068,12.068s3.344,3.068,5.065,3.068a3.068,3.068,0,1,0,0-6.136C15.412,9,12.068,12.068,12.068,12.068Z']],
  CryptoCurrencyNamecoin: ['crypto-currency-namecoin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M5.352 17.25L9.443 7.5', 'M14.557 17.25L18.648 7.5', 'M9.443 7.5L15.764 14.372', 'M8.236 10.378L14.557 17.25']],
  CryptoCurrencyBitcoinLaptop: ['crypto-currency-bitcoin-laptop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,5.25h-3a1.5,1.5,0,0,0-1.5,1.5v10.5h19.5V6.75a1.5,1.5,0,0,0-1.5-1.5H18', 'M23.205,21.386A1.5,1.5,0,0,1,21.75,23.25H2.25A1.5,1.5,0,0,1,.8,21.386L2.25,17.25h19.5Z', 'M11.25 20.25L13.5 20.25', 'M12.75,11.25a2.25,2.25,0,0,0,0-4.5,2.25,2.25,0,0,0,0-4.5h-3v9Z', 'M9.75 6.75L12.937 6.75', 'M12 2.25L12 0.75', 'M12 12.75L12 11.25']],
  CryptoCurrencyBitcoinWalletOpen: ['crypto-currency-bitcoin-wallet-open', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.48,18h2.14a3.108,3.108,0,0,0,3.15-3.047v-3.7', 'M2.94,5.394,13.888,8.505A3.769,3.769,0,0,1,16.48,12v9.01a2.052,2.052,0,0,1-2.6,2.167l-9.049-2.46a3.7,3.7,0,0,1-2.6-3.457V7.312A2.752,2.752,0,0,1,4.9,4.5H14.27', 'M10.480 16.500 A1.500 1.500 0 1 0 13.480 16.500 A1.500 1.500 0 1 0 10.480 16.500 Z', 'M17.27,7.5v-6h2.25a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M17.27 4.5L19.52 4.5', 'M18.77 1.5L18.77 0.75', 'M18.77 7.5L18.77 8.25']],
  CryptoCurrencyBitcoinBill: ['crypto-currency-bitcoin-bill', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,12a4.5,4.5,0,0,0-3-4.243V6A1.5,1.5,0,0,0,18,4.5H6A1.5,1.5,0,0,0,4.5,6V7.757a4.5,4.5,0,0,0,0,8.486V18A1.5,1.5,0,0,0,6,19.5H18A1.5,1.5,0,0,0,19.5,18V16.243A4.5,4.5,0,0,0,22.5,12Z', 'M10.5,15V9h2.25a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M10.5 12L12.75 12', 'M12 9L12 7.5', 'M12 15L12 16.5']],
  CryptoCurrencyMegacoin: ['crypto-currency-megacoin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M5.75,9.75H7A1.25,1.25,0,0,1,8.25,11v3.5a.5.5,0,0,1-.5.5H5a.5.5,0,0,1-.5-.5V11A1.25,1.25,0,0,1,5.75,9.75Z', 'M11.75,9.75H13A1.25,1.25,0,0,1,14.25,11v3.5a.5.5,0,0,1-.5.5H11a.5.5,0,0,1-.5-.5V11a1.25,1.25,0,0,1,1.25-1.25Z', 'M17.75,9.75H19A1.25,1.25,0,0,1,20.25,11v3.5a.5.5,0,0,1-.5.5H17a.5.5,0,0,1-.5-.5V11a1.25,1.25,0,0,1,1.25-1.25Z']],
  CryptoCurrencyBitcoinMining: ['crypto-currency-bitcoin-mining', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M15.75,20.25v-6H18a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M15.75 17.25L18 17.25', 'M17.25 14.25L17.25 13.5', 'M17.25 20.25L17.25 21', 'M11.628,7.487,3.951,16.308a1.874,1.874,0,0,1-2.652,0h0a1.875,1.875,0,0,1,0-2.651l8.819-7.679', 'M15.548,8.25a9.851,9.851,0,0,0-2.4-3.788C10.578,1.9,8.083,1.662,4.13.75a76.939,76.939,0,0,1,9.111,8.48']],
  CryptoCurrencyBitcoinCloudSync: ['crypto-currency-bitcoin-cloud-sync', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 15.75L3.75 12.75 6.75 15.75', 'M3.75,12.75v6a1.5,1.5,0,0,0,1.5,1.5h3', 'M12,3.75A2.982,2.982,0,0,0,9.708,4.835,4.489,4.489,0,1,0,5.25,9.75H12a3,3,0,0,0,0-6Z', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M15.75,20.25v-6H18a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M15.75 17.25L18 17.25', 'M17.25 14.25L17.25 13.5', 'M17.25 20.25L17.25 21']],
  CryptoCurrencyPeercoin: ['crypto-currency-peercoin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M18.75,9.375A4.125,4.125,0,0,1,14.625,13.5H10.5V5.25h4.125A4.125,4.125,0,0,1,18.75,9.375Z', 'M10.5 13.5L10.5 19.159', 'M7.5,19.159V6.535A1.189,1.189,0,0,1,8.659,5.25H10.5', 'M6 16.5L12 16.5', 'M13.914,10.84a1.561,1.561,0,0,1-.645-1.266V7.727a2.561,2.561,0,0,1,2.412,1.7A1.206,1.206,0,0,1,13.914,10.84Z']]
};
exports["default"] = _default;